module.exports = __webpack_public_path__ + "media/v2/components/Contests/shared/Players/Player/Modal/img/Warning-ca9932f82c0520c3353bad4e8db07339.svg";